export const routes = {
   LOGIN: '/login',
   REGISTER: '/register',
   FORGOTPASSWORD: '/forgotpassword',
   HOME: '/home',
   VERIFICATION: '/verification',
   RESENDVERIFICATION: '/resendverification',
   LOGOUT: '/logout',
   PROFILE: '/profile',
   RESETPASSWORD: '/reset_password',

   PAYMENT: '/payment',
   MYPLAN: '/myplan',
   PLANS: '/plans',
   
   SONG: '/song/:songId',
   PLAYLIST: '/playlist/:playlistId',
};

export const formInputTextErrorStyle = {
   color: 'rgb(221, 39, 38)',
   fontSize: '13px',
   paddingRight: '150px',
};

export const ProfileformInputTextErrorStyle = {
   color: 'rgb(221, 39, 38)',
   fontSize: '13px',
   paddingRight: '10px',
};

export const card_element = {
   padding: '11.4px 12px',
   border: '1px solid black !important',
};


export const PLATFORM_TYPE = {
   admin: "admin",
   stripe: "stripe",
   ios: "ios",
   android: "android"
}

export const SUBSCRIPTION_TYPE = {
   monthly: {
      price: 7.99,
      interval: "month",
      plan: "Monthly",
      type: "monthly"
   },
   yearly: {
      price: 79.99,
      interval: "year",
      plan: "Yearly",
      type: "yearly"
   }
}
